export const WaitingRoomStatus = {
  WAITING: 'waiting',
  ADMITTED: 'admitted',
  REJECTED: 'rejected'
}

export const MediaTypes = {
  VIDEO: 'video',
  AUDIO: 'audio'
}

export const MediaRestrictionStatus = {
  RESTRICTED: 'restricted',
  UNRESTRICTED: 'unrestricted'
}
